const distanceChart = {
  chart: {
    type: 'areaspline',
    height: 270
  },
  title: {
    text: 'Distance Traveled',
    align: 'left'
  },
  yAxis: {
    title: {
      text: 'Distance (km)'
    }
  },
  xAxis: {
    categories: [],
    accessibility: {
      rangeDescription: 'Range: Last 7 Days'
    },
    title: {
      text: 'Last 7 days'
    },
    labels: {
      rotation: 0
    }
  },
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      label: {
        connectorAllowed: false
      },
      pointStart: 0,
      marker: {
        enabled: true,
        radius: 3
      }
    }
  },

  series: [
    {
      name: 'Distance Travelled',
      showInLegend: false,
      data: []
    }
  ],

  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }
    ]
  }
};

export { distanceChart };
